<template>
  <div class="terminal-management">
    <div class="terminal-header">
      <a-button icon="arrow-left" @click="handleBack">返回</a-button>
      <div class="terminal-title">终端管理</div>
      <a-button type="primary" icon="export" @click="handleExportExcel">导出EXCEL</a-button>
    </div>

    <a-table
      :loading="loading"
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="list.content || []"
      :pagination="{
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: list.totalElements || 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: handlePageChange,
        onShowSizeChange: handlePageSizeChange
      }">
      <span slot="status" slot-scope="text, record">
        <span :style="{ color: record.online ? '#52c41a' : '#ff4d4f' }">{{ record.online ? '在线' : '离线' }}</span>
      </span>
      <span slot="action" slot-scope="record">
        <a @click="handleRestore(record)">恢复出厂设置</a>
      </span>
    </a-table>
  </div>
</template>

<script>
import { exportHistory, getTerminalHistory } from '@/api/projectItem'

export default {
  name: 'TerminalManagement',
  props: {
    code: {
      type: String,
      required: true
    },
    subProjectName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      list: [],
      pagination: {
        current: 1,
        pageSize: 10
      },
      keyword: '',
      columns: [{
        title: '二级项目名称',
        dataIndex: 'secondName',
        width: 120
      }, {
        title: '设备型号',
        dataIndex: 'model',
        width: 120
      }, {
        title: '机芯信息',
        dataIndex: 'chip',
        width: 100
      }, {
        title: 'MAC地址(有线)',
        dataIndex: 'mac',
        width: 150
      }, {
        title: '系统版本信息',
        dataIndex: 'systemVersion',
        width: 120
      }, {
        title: '激活时间',
        dataIndex: 'gmtCreate',
        width: 160
      }]
    }
  },
  mounted () {
    this.loadTerminalList()
  },
  methods: {
    loadTerminalList () {
      this.loading = true
      const params = {
        code: this.code,
        keyword: this.keyword,
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      getTerminalHistory(params).then(res => {
        if (res.code === 1) {
          this.list = res.data || []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleBack () {
      this.$emit('back')
    },
    handleExportExcel () {
      exportHistory({
        code: this.code,
        keyword: this.keyword
      }).then(res => {
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '终端列表.xlsx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message.success('导出成功')
      }).catch(err => {
        console.log(err)
        this.$message.error('导出失败')
      })
    },
    handleRestore (record) {
      // TODO: 实现恢复出厂设置功能
      this.$message.info(`恢复出厂设置：${record.deviceModel}`)
    },
    handlePageChange (page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.loadTerminalList()
    },
    handlePageSizeChange (current, size) {
      this.pagination.current = 1
      this.pagination.pageSize = size
      this.loadTerminalList()
    }
  }
}
</script>

<style lang="less" scoped>
.terminal-management {
  .terminal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .terminal-title {
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>
